import { createReducer } from 'app-webtech-core/reducers/createReducer';
import {
  CHANGE_CURRENT_PLAYING,
  CHANGE_SELECTED_INDEX,
  EXPAND,
  SET_HOURS,
  SET_AUTOPLAY,
  SET_LIST,
  SET_PREV_CONTENT_KIND,
  SHRINK,
  SHOW_EPISODE_INFO_DIALOG,
  HIDE_EPISODE_INFO_DIALOG,
  CHANGE_SELECTED_CATEGORY,
} from '../actions/types';
import { guideChangeSelectedIndexReducer } from './changeSelectedIndex';
import { guideChangeCurrentPlayinIndexReducer } from './changeCurrentPlayingIndex';
import { guideExpandReducer } from './expand';
import { guideShrinkReducer } from './shrink';
import { guideSetAutoPlayReducer } from './setAutoPlay';
import { guideSetHoursReducer } from './setHours';
import { guideSetListReducer } from './setList';
import { guideSetPrevContentKindReducer } from './setPrevContentKind';
import { guideShowEpisodeInfoDialogReducer } from './showEpisodeInfoDialog';
import { guideHideEpisodeInfoDialogReducer } from './hideEpisodeInfoDialog';
import { guideChangeSelectedCategoryReducer } from './changeSelectedCategory';

/**
 * selectedIndex:
 *   is the index that should be highlighted in the Guide, as is the current selected.
 *   ie if the user uses up/down, it will go selectedIndex +/- 1
 *
 * currentPlayingIndex:
 *   is the index in the Guide of the channel that is currently showing in the player.
 *
 * previousPlayingIndex:
 *   is the index in the Guide of the channel that was shown in the player before current one
 *
 * Note:
 *   currentPlayingIndex and previousPlayingIndex are not part of state.player because they are
 *   related to guide's index, not to player/channel id
 */
export const defaultState = {
  isAutoPlay: false,
  selectedIndex: -1,
  selectedCategory: -1,
  currentPlayingIndex: -1,
  previousPlayingIndex: -1,
  previousContentKind: null,
  expanded: false,
  list: [],
  hours: [],
};

export const guideReducer = createReducer(defaultState, {
  [CHANGE_SELECTED_INDEX]: guideChangeSelectedIndexReducer,
  [CHANGE_SELECTED_CATEGORY]: guideChangeSelectedCategoryReducer,
  [CHANGE_CURRENT_PLAYING]: guideChangeCurrentPlayinIndexReducer,
  [EXPAND]: guideExpandReducer,
  [SHRINK]: guideShrinkReducer,
  [SET_AUTOPLAY]: guideSetAutoPlayReducer,
  [SET_HOURS]: guideSetHoursReducer,
  [SET_LIST]: guideSetListReducer,
  [SET_PREV_CONTENT_KIND]: guideSetPrevContentKindReducer,
  [SHOW_EPISODE_INFO_DIALOG]: guideShowEpisodeInfoDialogReducer,
  [HIDE_EPISODE_INFO_DIALOG]: guideHideEpisodeInfoDialogReducer,
});
